import { Table, Pagination, Select } from "antd";
import { getAllDeals, getDealsOnStatus, searchTheDeal, updateTheDeal } from "../../HttpRequest/deals";
import { useState, useEffect } from "react";
import Header from "../../Header/Header";
import SideBar from "../../SideBar/SideBar";
import "../normalsearch.css";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Footer from "../../Footer/Footer";
import { getAllLoanUsers, searchTheLoanUser } from "../../HttpRequest/loanApplications";


const LoanApplications = () => {
  const [pagedata, setPageData] = useState();
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });
  const [isFocused1, setIsFocused1] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [data, setData] = useState([]);
  const [checkedIndex, setCheckedIndex] = useState(1);
  const [profileData, setProfileData] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
  });


  useEffect(() => {
    fetchData();
  }, [pageInfo]);
  const fetchData =()=>{
    getAllLoanUsers(pageInfo.page, pageInfo.size).then((result) => {
      console.log("result --->>",result);
    setPageData(result.data.metadata);
    setCheckedIndex(1);
    setProfileData(result.data.data);
    setData(result.data.data);
  });
  }

  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(() => ({
      [name]: value,
    }));
  };
  const filterDealsBasedOnStatus = async (index, Status) => {
    getDealsOnStatus(Status, pageInfo.page, pageInfo.size).then(
      (response) => {
        console.log("filter responce-->", response);
        if (response.request.status == 200 || response.request.status == 201) {
          setPageData(response.data.metaData);
          setData(response.data.data);
          console.log("ResponseStatus", response.data.data);
          setCheckedIndex(index);
        }
      }
    );
  };
  const handleSelectChange = async (value, id) => {
    const singleProfile = profileData.find((item) => item.id === id);
    const updatedProfile = { ...singleProfile, status: value };
    const response = await updateTheDeal(id, updatedProfile);
    if (response) {
      fetchData();
    }
    console.log(`Selected ${value} for row id ${id}`);
  };
  const applicationFilter = () => {
    // let status ="";
    // if(checkedIndex == 2){
    //    status ="open";
    // }else if(checkedIndex ==3){
    //   status ="InProgress";
    // }else if(checkedIndex == 4){
    //   status = "closed"
    // }else{
    //   status = "All"
    // } 
    // const data ={
    //   ...formData,
    //   status:status,
    // }
    console.log("Filter criteria:", formData);
    searchTheLoanUser(pageInfo.page, pageInfo.size, formData)
      .then((response) => {
        const result = response.data.data;
        console.log("response of the  search users==>", result);
        setData(result);
        setPageData(response.data.metaData);
      })
      .catch((error) => {
        console.error("Error filtering data:", error);
      });
    };

    const mystyle = {
      width: "90%",
      height: "2.2rem",
      borderRadius: "0.6rem",
      border: "none",
      outline: "none",
      display: "flex",
      alignItems: "center",
      gap:'6px'
    };
    const searchbarStyle = {
      display: "flex",
      // backgroundColor: "transparent",
      alignItems:'center',
  
      // backgroundColor: "white",
      width: "50%",
      borderRadius: "15rem",
      marginLeft: "25%",
      justifyContent: "end",
      // boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
  
    };
  const columns = [
    {
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName',
    },
    {
      title: 'Phone Number',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: "18%",
    //   render: (_, data) => (
    //     <Select
    //       value={data.status}
    //       onChange={(value) => {
    //         handleSelectChange(value, data.id);
    //       }}
    //       style={{ width: "75%" }}
    //     >
    //       <Option value="Open">Open</Option>
    //       <Option value="InProgress">In Progress</Option>
    //       <Option value="Closed">Closed</Option>
    //     </Select>
    //   ),
    // },
  ];

  return (
    <>

 <div className="main-wrapper">

    <div>
    <Header />
        <SideBar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">Loan Applications</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Loans</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div
              className="checkboxgroup"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 1}
                  onClick={() => {
                    fetchData();
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  All
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 2}
                  onClick={() => {
                    filterDealsBasedOnStatus(2, "Open");
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  Open
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 3}
                  onClick={() => {
                    filterDealsBasedOnStatus(3, "InProgress");
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  In-Progress
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox2"
                  value="option2"
                  checked={checkedIndex === 4}
                  onClick={() => {
                    filterDealsBasedOnStatus(4, "Closed");
                  }}
                />
                <label class="form-check-label" for="inlineCheckbox2">
                  Closed
                </label>
              </div>
            </div> */}
            <div style={{ textAlign: "center" }}>
            <div style={searchbarStyle}>
              <div style={mystyle}>
                <input
                             className={isFocused ? "focused gridsearchinput" : "gtr gridsearchinput"}
                  type="text"
                  placeholder="Full Name"
                  name="fullName"
                
      
                  value={formData.fullName}
                  onChange={handleChange}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                />
                <input
                             className={isFocused ? "focused gridsearchinput" : "gtr gridsearchinput"}
                  type="text"
                  placeholder="Email"
                  name="email"
                
      
                  value={formData.email}
                  onChange={handleChange}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                />
                <input
                     className={isFocused1 ? "focused gridsearchinput" : "gtr gridsearchinput"}
                     type="text"
                     placeholder="Phone Number"
                     name="phoneNumber"
                     value={formData.phoneNumber}
                     onChange={handleChange}
                     onFocus={() => setIsFocused1(true)}
                     onBlur={() => setIsFocused1(false)}
                />
              </div>
              <div
                className="searchbox"
                type="button"
                onClick={() => applicationFilter()}
              >
                <i className="fas fa-search"></i>
              </div>
            </div>
            </div>
            <div>
            </div>
            <div className="width=100%"></div>
            <div style={{ marginTop: "1rem" ,    boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", marginBottom: "1rem"}}>
              <Table pagination={false} columns={columns} dataSource={data} 
                    // rowClassName={rowClassName}

              />
              {pagedata?.totalPages > 1 && (
                <Pagination
                  pageResponce={pagedata}
                  pagedataToParent={setPageInfoData}
                />
              )}
            </div>
          </div>
          <Footer />
        </div>
    </div>
        </div>
        </>
  );
};

export default LoanApplications;
